module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-welcome-background-honda.e531fa71.png";